<template>
  <v-toolbar color="primary" fixed dark app>
    <v-toolbar-title class="ml-0">
      <v-toolbar-side-icon @click.stop="handleDrawerToggle" />
    </v-toolbar-title>
    <v-spacer />
    <div style="width: 150px">
      <l-select :items="languages" />
    </div>
    <v-btn icon @click="handleFullScreen()">
      <v-icon>fullscreen</v-icon>
    </v-btn>
    <!-- <v-btn icon>
      <v-badge color="red" overlap>
        <span slot="badge">10</span>
        <v-icon medium>person_add</v-icon>
      </v-badge>
    </v-btn>-->

    <confirm-role-menu />
    <notification-menu />
    <support-menu v-if="isAdmin" />
    <v-menu
      offset-y
      origin="center center"
      :nudge-bottom="10"
      transition="scale-transition"
    >
      <v-btn slot="activator" icon large flat>
        <v-avatar size="30px">
          <v-icon medium> person </v-icon>
        </v-avatar>
      </v-btn>
      <v-list class="pa-0">
        <v-list-tile
          v-for="(item, index) in items"
          :key="index"
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          ripple="ripple"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          @click="item.click"
        >
          <v-list-tile-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>
<script>
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import toggleFullScreen from '../../helpers/toggleFullScreen'
import LSelect from '../widgets/language/LSelect'
import ConfirmRoleMenu from '@/components/widgets/notifications/ConfirmRoleMenu'
import NotificationMenu from '@/components/widgets/notifications/NotificationMenu'
import SupportMenu from '@/components/widgets/notifications/SupportMenu'

export default {
  name: 'AppToolbar',
  components: {
    NotificationMenu,
    ConfirmRoleMenu,
    SupportMenu,
    LSelect,
  },
  data() {
    return {
      languages: [
        { flag: 'es', language: 'es', title: 'Español' },
        { flag: 'es-ct', language: 'ca', title: 'Català' },
        { flag: 'gb', language: 'en', title: 'English' },
        { flag: 'it', language: 'it', title: 'Italiano' },
        { flag: 'fr', language: 'fr', title: 'Français' },
        { flag: 'de', language: 'de', title: 'Deutsche' },
      ],
      isChangeSeasonActive: false,
    }
  },
  computed: {
    ...mapState({
      profileModalActive: (state) => state.auth.profileModalActive,
      badge: (state) => state.notifications.badge,
      auth: (state) => state.auth.user,
    }),

    items() {
      return [
        {
          icon: 'account_circle',
          title: this.$t('titles.users.profile'),
          click: () => {
            this.toggleProfileModal()
          },
        },
        {
          icon: 'exit_to_app',
          href: '#',
          title: this.$t('action.buttons.logout'),
          click: () => {
            this.$store.dispatch('auth/logout')
          },
        },
      ]
    },
    changeSeasonValidate() {
      return moment().month() + 1 === 7
    },
  },
  methods: {
    ...mapActions({
      toggleProfileModal: 'auth/toggleProfileModal',
    }),
    handleDrawerToggle() {
      window.getApp.$emit('APP_DRAWER_TOGGLED')
    },
    handleFullScreen() {
      toggleFullScreen()
    },
  },
}
</script>
